// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AdminSettingsEmailsContainer_wrap__3y_Cu","title":"AdminSettingsEmailsContainer_title__3r7-C","filter":"AdminSettingsEmailsContainer_filter__2Wq5j"};